import classNames from 'classnames'
import { useState } from 'react'
import Widget from './widget'
import Carousel from '@/stories/components/Common/Carousel/Carousel'
import Text from '@/stories/components/Common/NewText'
import { Collection } from '@/components/Stocks/Widgets/types'

interface IProps {
  heading?: string
  collection?: Collection[]
  parentClass?: string
  width?: number
  parentWidthClass?: string
}

const Infographics = (props: IProps) => {
  const {
    heading,
    collection,
    parentClass = 'p-4 md:p-6',
    width,
    parentWidthClass,
  } = props
  const [selectedCollection, setCollection] = useState(0)
  const [selectedIndex, setIndex] = useState(0)
  if (!heading) {
    return null
  }

  const { title, list } = collection?.[selectedCollection] ?? {}

  return (
    <div
      className={classNames(
        'bg-brand-white rounded-xl pb-6 lg:pb-0',
        parentClass,
      )}
    >
      <Text tag="h2" appearance="heading3" addClassName="text-brand-black">
        {heading}
      </Text>

      {collection &&
        collection.length > 0 &&
        collection.some(el => el.chip_name) && (
          <div className="no-scrollbar flex flex-row overflow-auto py-3">
            {collection.map(({ chip_name }, index) => {
              if (!chip_name) return null

              return (
                <div key={`collection${index}`} className="pr-2">
                  <button
                    onClick={() => setCollection(index)}
                    className={classNames('rounded-lg px-2', {
                      'bg-brand-tertiary-blue text-brand-blue-azureRadiance':
                        selectedCollection === index,
                      'bg-brand-grey-background border-brand-grey-base text-brand-grey-base':
                        selectedCollection !== index,
                    })}
                  >
                    <Text appearance="caption">{chip_name}</Text>
                  </button>
                </div>
              )
            })}
          </div>
        )}

      {title && (
        <Text tag="h3" appearance="subtitle2" addClassName=" text-brand-black">
          {title}
        </Text>
      )}

      <Text
        appearance="body1"
        addClassName="text-brand-grey-dark py-2 lg:line-clamp-3 line-clamp-4"
      >
        {list?.[selectedIndex]?.subtitle}
      </Text>
      <Carousel
        showArrows
        stopAutoPlay
        dots
        showDotsOnMobileOnly
        showArrowsOnDesktop
        onIndexChange={idx => {
          setIndex(idx)
        }}
      >
        <ul className="mb-6 mt-2 flex gap-3">
          {list?.map((el, key) => (
            <Widget
              {...el}
              key={`${el.image}-${key}`}
              width={width}
              parentWidthClass={parentWidthClass}
            />
          ))}
        </ul>
      </Carousel>
    </div>
  )
}

export default Infographics
